import { unwrapResult } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import { templatesModel } from '@/entities/templates';

import type { SaveTemplateVersion } from '../config';
import { toTemplateVersionRequest } from '../lib';

// A working copy's structure saved as the next active version of the clinic's
// template series, based on the version the copy was made from: a save
// another save overtook is refused instead of replacing it.
export const useSaveTemplateVersion = (): SaveTemplateVersion => {
  const dispatch = useAppDispatch();
  const organizationId = useAppSelector(
    organizationModel.selectors.selectCurrentOrganizationID,
  );

  return async (draft, source) => {
    const action = await dispatch(
      templatesModel.createDocumentTemplateVersion(
        toTemplateVersionRequest({
          template: draft.template,
          source,
          organizationId,
          expectLatest: true,
        }),
      ),
    );
    return {
      template: unwrapResult(action),
      warnings: templatesModel.createDocumentTemplateVersion.fulfilled.match(
        action,
      )
        ? action.meta.warnings
        : [],
    };
  };
};
